import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import Toggle from '../../toggle'
import { Instructions } from './field-instructions'
import Title from './field-title'

const VisiblityToggle = styled(Toggle)`
    width: 200px;
`

type Props = {
    className?: string
    field: CreationToolUploadField
    instructions?: string
    isPublic?: boolean
    onChange: (isPrivate: boolean) => void
}

const CreationPrivacyField = ({ className, field, isPublic = false, instructions, onChange }: Props) => {
    const learnMoreUrl = CreationToolUploadField.learnMoreUrl(field)

    return (
        <UploadFieldBlock className={className}>
            <Title field={field} />
            <VisiblityToggle onLabel="Public" offLabel="Private" isOn={isPublic} onToggle={onChange} />
            {instructions && (
                <Instructions>
                    {instructions}{' '}
                    {learnMoreUrl && (
                        <a href={learnMoreUrl} target="_blank" rel="noopener noreferrer">
                            Learn More
                        </a>
                    )}
                </Instructions>
            )}
        </UploadFieldBlock>
    )
}

export default CreationPrivacyField
